import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SignoutService {
  constructor(private http: HttpClient) {}

  invoke(): Observable<any> {
    // Bearer is read at call time — the access token must still be valid
    // when the BE GlobalSignOut runs, so the caller invokes this BEFORE
    // clearing localStorage.
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:
        'Bearer ' + (localStorage.getItem(environment.keys.accessToken) || ''),
    });
    return this.http.post<any>(
      environment.apiUrl + 'signout',
      null,
      { headers }
    );
  }
}
